module.exports = __webpack_public_path__ + "media/images/iconSquadBet__edit-d4e03de94f25cc895d789abc63afd440.png";